module.exports = __webpack_public_path__ + "static/media/gasOnline-app-slides-preview-image.a4eba7ff.png";